import styled from 'styled-components';
import { Descriptions, Space } from 'antd';
import { EditOutlined } from '@ant-design/icons';

export const TitleSection = styled(Space)`
  margin-bottom: 1rem;
`;

export const BravoEditIcon = styled(EditOutlined)`
  color: var(--primary-color);
`;

export const WhiteDescriptions = styled(Descriptions)`
  background-color: var(--white);
`;
